import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonService } from './../common.service';
import { Router } from '@angular/router';
import { CommonVariablesService } from './../common-variables.service';

@Component({
  selector: 'app-encrypt-pdf',
  templateUrl: './encrypt-pdf.component.html',
  styleUrls: ['./encrypt-pdf.component.css']
})
export class EncryptPdfComponent implements OnInit {

  encryptionForm: FormGroup;
  submitted = false;
	pdfSource =  "";
	isShowPDF = false;
  constructor(
    private fb: FormBuilder,
    private commonService: CommonService,
    private commonVariablesService: CommonVariablesService,
    private router: Router,
  ) { }

  ngOnInit(): void {
	 window.localStorage.setItem('pageName','');
    this.encryptionForm = this.fb.group({
      certificate_no: ['', [Validators.required, Validators.maxLength(10), Validators.pattern(`[cC]{1}[0-9]{9}`)]],
      encryption_key: ['', [Validators.required, Validators.maxLength(15), Validators.pattern(`[a-zA-Z0-9]{15}`)]]
    });
  }

  get f() { return this.encryptionForm.controls; }

  async downloadAndPreviewPdf() {

    this.submitted = true;
    if (this.encryptionForm.invalid) {
      return
    }
    
    const url = `${this.commonVariablesService.baseURL}api/v1/marine_declaration/pdf_doc?certificate_no=${this.f.certificate_no.value}&enc_key=${this.f.encryption_key.value}`;

    let ret: any = await this.commonService.previewPdf(url, false, false);
    if (ret.status == 0) {
      this.pdfSource = ret.data;
      this.isShowPDF = true;
      this.resetForm();
    } else {
      this.commonService.errorsmsg(ret.data, '');
    }
  }

  async resetForm() {
    this.submitted = false;
    this.encryptionForm.reset();
  }

  goToLogin() {
		sessionStorage.clear();
		this.router.navigate(['/login']);
  }
  
  goToBack() {
    this.isShowPDF = false;
  }


}